<div class="GovernanceMeetingContainer">
  <!-- <div class="banner">
    </div> -->
  <nav *ngIf="!data.isModal" aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a (click)="goHome()">Home</a>
      </li>
      <li class="breadcrumb-item active" aria-current="page">
        Governance Meeting
      </li>
    </ol>
  </nav>
  <label  *ngIf="!data.isModal"  class="pageTitle">Governance Meeting</label>

  <div class="actionsWrapper" >
    <label
      >Past Meeting and Action Items
      <motif-icon  [motif-tooltip]="pastMeetingsSort === 'asc'?'Sort descending': 'Sort ascending'" (click)="sortByDate()" [src]="'/assets/icons/content/ic_sort_24px.svg'" ></motif-icon>
    </label>
    <div class="dataFilterContainer">
      <label>
        <span>Quarter</span>
         <!-- <span (click)="updateQuarter()" class="clearButton">Clear All</span> -->
      </label>
      <div
        motifDropdown
        ngClass="dataFilter"
        placement="bottom-right"
        scrollStrategy="reposition"
        [autoClose]="true"
        [closeOnBackdropClick]="true"
        [open]="false"
      >
        <button
          aria-label="Dropdown toggle example"
          motifDropdownToggle
          id="selectQuarterDropdown"
        >
          {{ selectedQuarter.name }} {{selectedQuarter.year}}
          <motif-icon [src]="'/assets/icons/navigation/ic_expand_more_24px.svg'"></motif-icon>
        </button>
        <div motifDropdownMenu aria-labelledby="selectQuarterDropdown">
          <button
            (click)="updateQuarter(item)"
            motifDropdownItem
            [ngClass]="{'active': item.name === selectedQuarter.name && item.year === selectedQuarter.year}"
            *ngFor="let item of quarterDropDown; track: item"
          >
            {{ item.name }} {{item.year}}
          </button>
        </div>
      </div>
    </div>
    <label>Upcoming Meeting</label>
  </div>
  <div class="govMeetingList">
    <div class="past" *ngIf="sortedMeetings.length">
      <ng-container *ngFor="let meeting of sortedMeetings; track: meeting">
        <app-meeting-card (openDetailsModalParent)="openDetailsModal(meeting)" [meeting]="meeting" [type]="'past'"></app-meeting-card>
      </ng-container>
    </div>
    <div class="noDataContaner" *ngIf="!sortedMeetings.length">
      <span>No Meetings</span>
    </div>
    <div class="upcoming" *ngIf="upcomingMeetings.length">
      <ng-container *ngFor="let meeting of upcomingMeetings; track: meeting">
        <app-meetings [meeting]="meeting" [type]="'upcoming'"></app-meetings>
      </ng-container>
    </div>
    <div class="noDataContaner" *ngIf="!upcomingMeetings.length">
      <span>No Meetings</span>
    </div>
  </div>
</div>
